import PropTypes from 'prop-types'
import { CameraModels } from '../../models/cameras/camera-models'
import { CameraOperationModes } from '../../models/cameras/camera-operation-modes'
import { CameraStatus } from '../../models/cameras/camera-status'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'

import { cameraViewPropType } from './camera-view-prop-type'

/**
 * @typedef {Object} Camera
 * @property {string} [cameraId]                     - Id of the camera.
 * @property {string} [imei]                         - imei of the camera.
 * @property {string} [serialNumber]                 - serialNumber of the camera.
 * @property {CameraView[]} [cameraViews]            - List of avialable views of the camera.
 * @property {string} [objectId]                     - Id of the object the camera is attached to.
 * @property {string} [driverId]                     - Id of the driver the camera is attached to.
 * @property {string} [status]                       - Status of the camera, can be one of FRONT, DRIVER, AUXILIARY
 * @property {Position} [location]                   - last location of the camera.
 * @property {iso8601DateTimeSting} [lastSeenOnline] - The time when the camera was online last time in ISO8601 UTC format.
 * @property {Object} [details]
 * @property {string} [details.modelName]            - Model of the camera
 * @property {string} [details.firmwareVersion]      - Firmware version of the camera
 * @property {string} [operationMode]                - Operation mode of the camera, can be PRIMARY (camera is a standalone device), SECONDARY
 */
export const cameraPropType = PropTypes.shape({
    cameraId: PropTypes.string.isRequired,
    cameraViews: PropTypes.arrayOf(cameraViewPropType),
    driverId: PropTypes.string,
    imei: PropTypes.string.isRequired,
    objectId: PropTypes.string,
    serialNumber: PropTypes.string.isRequired,
    lastSeenOnline: iso8601PropType,
    location: PropTypes.shape({
        locationDescription: locationDescriptionPropType,
        position: positionPropType
    }),
    status: PropTypes.oneOf(Object.values(CameraStatus)).isRequired,
    details: PropTypes.shape({
        modelName: PropTypes.oneOf(Object.values(CameraModels)),
        firmwareVersion: PropTypes.string
    }),
    operationMode: PropTypes.oneOf(Object.values(CameraOperationModes))
})
